'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_scala$002eruntime$002e$002dAbstract$002dPartial$002dFunction from "./scala.runtime.-Abstract-Partial-Function.js";
var $p;
/** @constructor */
function $c_Lcom_raquo_laminar_nodes_ReactiveElement$$anon$1(reason$5) {
  this.zd = null;
  this.zd = reason$5;
}
export { $c_Lcom_raquo_laminar_nodes_ReactiveElement$$anon$1 as $c_Lcom_raquo_laminar_nodes_ReactiveElement$$anon$1 };
$p = $c_Lcom_raquo_laminar_nodes_ReactiveElement$$anon$1.prototype = new $j_scala$002eruntime$002e$002dAbstract$002dPartial$002dFunction.$h_sr_AbstractPartialFunction();
$p.constructor = $c_Lcom_raquo_laminar_nodes_ReactiveElement$$anon$1;
/** @constructor */
function $h_Lcom_raquo_laminar_nodes_ReactiveElement$$anon$1() {
}
export { $h_Lcom_raquo_laminar_nodes_ReactiveElement$$anon$1 as $h_Lcom_raquo_laminar_nodes_ReactiveElement$$anon$1 };
$h_Lcom_raquo_laminar_nodes_ReactiveElement$$anon$1.prototype = $p;
$p.gz = (function(x) {
  if ((x !== null)) {
    var r = x.ad;
    var x$3 = this.zd;
    if (((r === null) ? (x$3 === null) : (r === x$3))) {
      return true;
    }
  }
  return false;
});
$p.gt = (function(x, default$1) {
  if ((x !== null)) {
    var item = x.ac;
    var r = x.ad;
    var x$3 = this.zd;
    if (((r === null) ? (x$3 === null) : (r === x$3))) {
      return item;
    }
  }
  return default$1.j(x);
});
$p.de = (function(x) {
  return this.gz(x);
});
$p.cr = (function(x, default$1) {
  return this.gt(x, default$1);
});
var $d_Lcom_raquo_laminar_nodes_ReactiveElement$$anon$1 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lcom_raquo_laminar_nodes_ReactiveElement$$anon$1, "com.raquo.laminar.nodes.ReactiveElement$$anon$1", ({
  iL: 1,
  aO: 1,
  o: 1,
  t: 1,
  a: 1
}));
export { $d_Lcom_raquo_laminar_nodes_ReactiveElement$$anon$1 as $d_Lcom_raquo_laminar_nodes_ReactiveElement$$anon$1 };
